{
  "messages": {
    "processing": "Datei wird verarbeitet...",
    "dragHere": "Zieh deine SVG hierher."
  }
}
